import { Component, Input, ViewChild } from '@angular/core';
import { FileSectionTypes } from 'app/models/enums/FileSectionTypes';
import { FloatingPanelsComponent } from '../../../../../../shared/components/floating-panels/floating-panels.component';
import Task = Boo.Objects.Task;

@Component({
  selector: 'app-components-specialist-actioncomponents-page-optimization-shared-floating-panels',
  templateUrl: './floating-panels.component.html'
})
export class PageOptimizationFloatingPanelsComponent {
  @ViewChild(FloatingPanelsComponent) floatingPanelsComponent: FloatingPanelsComponent;

  @Input() orderingTask: Task;
  @Input() customer: Boo.Objects.Customer;
  @Input() taskId: number;
  @Input() showExternalAccess = false;
  @Input() showInformation = false;
  @Input() showTaskFiles = false;
  @Input() showCustomerFiles = false;
  @Input() showCustomerCampaign = false;

  FileSectionTypes = FileSectionTypes;

  fileCountUpdated(count: number): void {
    this.floatingPanelsComponent.setBadgeCountByTitle('Task Files', count);
  }
}
